import { FC, useRef } from 'react'
import { InView } from 'react-intersection-observer'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'

import 'react-h5-audio-player/lib/styles.css'

import PlayButton from './../../../assets/player/PlayButton.png'
import PauseButton from './../../../assets/player/PauseButton.png'
import BackButton from './../../../assets/player/BackButton.png'
import ForwardButton from './../../../assets/player/ForwardButton.png'
import styles from './Player.module.css'
import {
  OnResponseSubmit,
  PlayerExercise,
  StepResponse,
} from '../../../types/Exercise'
import { ResponseStatus } from '../../../common/utils/exercise'

interface PlayerProps {
  id: number
  data: PlayerExercise
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const baseUrl = process.env.REACT_APP_BASE_URL

const Player: FC<PlayerProps> = ({
  id,
  data,
  onResponseSubmit,
  stepResponse,
}) => {
  const { audioUrl } = data
  const playerRef = useRef<AudioPlayer>(null)

  // TODO: Replace with useSwiperSlide but need to account for multi-step slider
  const handleInViewChange = (inView: boolean) => {
    if (!inView) {
      playerRef.current?.audio.current?.pause()
    }
  }

  const handleOnPlay = () => {
    if (!stepResponse) {
      onResponseSubmit(id, ResponseStatus.COMPLETE)
    }
  }

  return (
    <InView onChange={handleInViewChange}>
      <AudioPlayer
        onPlay={handleOnPlay}
        src={`${baseUrl}/${audioUrl}`}
        ref={playerRef}
        customAdditionalControls={[]}
        layout="stacked-reverse"
        customVolumeControls={[]}
        style={{ backgroundColor: 'var(--color-background)' }}
        customProgressBarSection={[
          RHAP_UI.PROGRESS_BAR,
          RHAP_UI.CURRENT_TIME,
          RHAP_UI.DURATION,
        ]}
        customIcons={{
          play: (
            <div className={styles.playPauseBtnWrapper}>
              <img src={PlayButton} alt="PlayButton" />
            </div>
          ),
          pause: (
            <div className={styles.playPauseBtnWrapper}>
              <img src={PauseButton} alt="PauseButton" />
            </div>
          ),
          rewind: (
            <div className={styles.controlBtnWrapper}>
              <span className={styles.controlText}>15</span>
              <img src={BackButton} alt="BackButton" />
            </div>
          ),
          forward: (
            <div className={styles.controlBtnWrapper}>
              <span className={styles.controlText}>15</span>
              <img src={ForwardButton} alt="ForwardButton" />
            </div>
          ),
        }}
        progressJumpSteps={{
          backward: 15000,
          forward: 15000,
        }}
      />
    </InView>
  )
}

export default Player
